module.exports = __webpack_public_path__ + "img/document-folder.3b2ad8bb.svg";